/**
 * HTTP utility functions for centralized header management
 */

/**
 * Create standard HTTP headers using configuration values.
 *
 * Currently this only uses HTTP_ACCEPT from the runtime config.
 * The Authorization header is not set in the frontend and
 * is instead added server-side.
 *
 * @param {Object} config - Configuration object containing HTTP_ACCEPT
 * @returns {Object} Headers object for fetch requests
 */
export const createAuthHeaders = (config) => {
  return {
    'Accept': (config && config.HTTP_ACCEPT) || 'application/json',
  };
};

/**
 * Create headers for POST requests with JSON content.
 *
 * Uses the standard auth headers (currently just Accept) and
 * adds the Content-Type for JSON payloads.
 *
 * @param {Object} config - Configuration object passed through to createAuthHeaders.
 * @returns {Object} Headers object for POST requests.
 */
export const createJsonPostHeaders = (config) => {
  const base = createAuthHeaders(config);
  return {
    ...base,
    'Content-Type': 'application/json',
  };
};
